export const TeamQueryKeys = {
  fetchTeams: ['my-team'],
  fetchUserTeams: ['user-teams'],
  teamWithMembers: (id: number) => ['team-with-members', id],

};
